module.exports = __webpack_public_path__ + "img/cooperate_yh_03@2x.26aa803a.png";